const DependentsState = {
  data: []
}

export default DependentsState
